import CloseIcon from '@ixigo/icons/Close';
import Typography from '@ixigo/iui/Typography';
import { Fragment } from 'react/jsx-runtime';
import type { CancellationCharges } from '../../-api';

interface CancellationConfirmationProps {
	onClose: () => void;
	cancellationMetainfo: CancellationCharges['metaInfo'];
}

export const CancellationConfirmation = ({
	onClose,
	cancellationMetainfo,
}: CancellationConfirmationProps) => {
	const { imageUrl, title, subtitle } = cancellationMetainfo;
	return (
		<Fragment>
			<CloseIcon onClick={onClose} />
			<div className="flex flex-col gap-y-30">
				<div className="flex items-center justify-center ">
					<img src={imageUrl} alt="cancellation" className="size-[120px]" />
				</div>
				<div className="flex flex-col gap-y-15 text-center">
					<Typography variant="body-lg" fontWeight="medium">
						{title}
					</Typography>
					<Typography variant="body-md" className="text-secondary">
						{subtitle}
					</Typography>
				</div>
			</div>
		</Fragment>
	);
};
